import { Container, ThemeProvider } from "@material-ui/core";
import {
    Grid,
    createTheme,
} from "@mui/material";
import Box from "@mui/material/Box";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { SUPPLIERIDS } from "../../config/cacheKey";
import { GetFinancialSuppliersResponse } from "../../models/loanTemplate.model";
import { getFinancialSuppliers } from "../../services/loanTemplate.service";
import DevisionCardFinancial from "../../components/cards/devisionCardFinancial";

const theme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                rounded: { borderRadius: "1rem" },
            },
        },
    },
});
const style = {
    maxHeight: "78vh",
    overflow: "auto",
    overflowX: "hidden",
    paddingRight: "1.7vh",
    direction: "ltr",
    display: "grid",
    justifyItems: "center",
    paddingTop: '40px',
    paddingBottom: '24px',
    "&::-webkit-scrollbar": {
        width: 7,
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "#F9FAFC",
        border: "2px solid #DAE0E4",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#9AAFC4",
    },
};


const FinancialSupplier = () => {
    const [data, setData] = useState<GetFinancialSuppliersResponse[]>([]);
    const history = useHistory();


    useQuery<GetFinancialSuppliersResponse[]>(SUPPLIERIDS, getFinancialSuppliers, {
        onSuccess(data) {
            if (data) {
                setData(data);
            }
        },
        onError: () => { },
    });


    return (
        <>
            <ThemeProvider theme={theme} >
                <Container maxWidth="xl" style={{ paddingTop: '20px' }}>
                    <Grid container xs={12} className="suppliersListDetailContent" style={{ justifyContent: 'center' }}>
                        <span
                            className="financialListDetailTitle"
                        >تامین کنندگان مالی</span>
                        <Box sx={style}>
                            <Grid
                                container
                                xs={12}
                                spacing={2}
                                paddingBottom={"2rem"}
                                sx={{
                                    direction: "rtl",
                                }}
                            >
                                {data.map((item) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={6}
                                        xl={6}

                                        key={uuid()}
                                        onClick={() => {
                                            window.sessionStorage.setItem('logoSupplier', item.logo)
                                            window.sessionStorage.setItem('titleSupplier', item.title)
                                            history.push({
                                                pathname: "/FinancialSupplier1/FinancialSupplierDetailList",
                                                state: { id: item.id, logo: item.logo, title: item.title },
                                            });
                                            localStorage.setItem(
                                                "Supplier_ID",
                                                JSON.stringify(item.id)
                                            );
                                        }}
                                    >
                                        <DevisionCardFinancial {...item} borderRadius={"85px !important"} />
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Grid>
                </Container>
            </ThemeProvider>
        </>
    );
};

export default FinancialSupplier;
